import { h, Fragment } from 'preact';
import { Navigation } from '../../typing/enums';
import { PopupZoomInButton, PopupZoomOutButton } from './PopupZoomButtons.styled';

const PopupZoomButtons = props => (
  <Fragment>
    <PopupZoomInButton
      {...props}
      direction="right"
      navigation={Navigation.ALWAYS}
      icon="zoomIn"
      disabled={props.currentStep >= props.steps}
      onClick={props.zoomIn}
    />
    <PopupZoomOutButton
      {...props}
      direction="left"
      navigation={Navigation.ALWAYS}
      icon="zoomOut"
      disabled={props.currentStep === 0}
      onClick={props.zoomOut}
    />
  </Fragment>
);

export default PopupZoomButtons;
